export default __webpack_public_path__ + "fonts/74289d7167d1a2d2012d0727b1f1d464.woff";